import { StyleSheet } from 'react-native';
import { ONBOARDING_COLORS } from '../../src/tutorial/constants/onboardingContent.constants';

export const coreActionArtStyles = StyleSheet.create({
  scene: {
    width: '100%',
    alignItems: 'center',
    gap: 28,
  },
  heroGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
  },
  callCard: {
    marginLeft: -22,
    maxWidth: 172,
    flexShrink: 1,
    backgroundColor: ONBOARDING_COLORS.surface,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    paddingVertical: 12,
    paddingHorizontal: 14,
    gap: 5,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.5,
    shadowRadius: 12,
    elevation: 8,
  },
  callLabel: {
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.8,
    color: ONBOARDING_COLORS.gold,
  },
  callMatchup: {
    fontSize: 16,
    fontWeight: '800',
    color: ONBOARDING_COLORS.textPrimary,
  },
  rewardPill: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 5,
    backgroundColor: ONBOARDING_COLORS.mint,
    borderRadius: 999,
    paddingVertical: 3,
    paddingHorizontal: 8,
    marginTop: 2,
  },
  rewardCoin: {
    width: 13,
    height: 13,
  },
  rewardText: {
    fontSize: 11,
    fontWeight: '700',
    color: ONBOARDING_COLORS.ink,
  },
  headlineWrap: {
    width: '100%',
    paddingHorizontal: 8,
  },
});
